import { useState, type ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import type Input from "../../components/common/Input";
import Tooltip from "../../components/common/Tooltip";
import "../../components/common/Input.css";

interface Props extends Omit<ComponentProps<typeof Input>, "onChange"> {
	onChange: (fieldName: string, value: number | null, isIncomplete?: boolean) => void;
}

const MaterialBalanceInput = (props: Props) => {
	const { t, i18n } = useTranslation();
	const formatValue = () => {
		return props.value === null || isNaN(props.value)
			? ''
			: props.value.toString().replace('.', i18n.language === 'ru' ? ',' : '.');
	};
	const [display, setDisplay] = useState(() => ({
		value: props.value,
		language: i18n.language,
		text: formatValue()
	}));
	if (display.value !== props.value || display.language !== i18n.language) {
		const keepDraft = props.value === null && display.text !== '' && isNaN(parseFloat(display.text.replace(',', '.')));
		setDisplay({
			value: props.value,
			language: i18n.language,
			text: keepDraft ? display.text : formatValue()
		});
	}

	return (
		<div className={`field-wrapper ${props.className || ""} ${props.error ? "error" : ""}`}>
			<Tooltip content={props.tooltip}>
				<div className="input-wrapper">
					<input
						id={props.id}
						data-testid={props.id}
						type="text"
						inputMode="decimal"
						value={display.text}
						onChange={event => {
							const text = event.target.value;
							if (!/^-?\d*[,.]?\d*$/.test(text)) return;

							setDisplay({ value: props.value, language: i18n.language, text });
							const value = parseFloat(text.replace(',', '.'));
							if (text === '' || text === '-') {
								props.onChange(props.name, null);
							} else if (isNaN(value)) {
								props.onChange(props.name, null, true);
							} else {
								props.onChange(props.name, value);
							}
						}}
						className="number-input"
						name={props.name}
						disabled={props.disabled}
					/>
					{props.error && (
						<span className="input-error">{t(props.error, props.errorParams ?? undefined)}</span>
					)}
				</div>
			</Tooltip>
		</div>
	);
};

export default MaterialBalanceInput;
